module.exports = __webpack_public_path__ + "static/media/human2.5f7b676e.jpg";